export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              name: 'Seção Tempo',
              attributes: { class: 'item-time-line-5' },
              components: [
                 {
                   type:'image', 
                   tagName:'img',  
                   attributes:{class:'icon-time-line-5', src: 'https://placehold.co/110x110'}, 
                 },
                 {
                    type: 'div', 
                    attributes: { class: 'line-5'}, 
                 },
                 {
                    type: 'div', 
                    attributes: { class: 'dot-5'}
                 },
                 {
                    type: 'text', 
                    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    attributes: { class: 'time-text-3'}
                 }
              ],
              styles: `
               .line-5{
                width: 3px; 
                height: 90px; 
                background: #363940; 
               }
              .dot-5{
                width: 15px; 
                height: 15px; 
                border: 3px solid #363940; 
                border-radius: 100%; 
              }
              .icon-time-line-5{
                width: 100%; 
                border-radius: 100%; 
              } 
              .item-time-line-5{
                width: 11%;
                display: flex;
                flex-direction: column;
                align-items: center;
              }
              .time-text-3{
                font-size: 16px; 
                text-align: center; 
                color: #363940; 
                margin-top: 15px; 
              }

              @media (max-width: 992px){
                .item-time-line-5{
                    width: 47%; 
                  }
              }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};